import _ from '@/utils/lodash-optimized'
import moment from 'moment'
import { createSelector } from 'reselect'

import * as Compartment from './compartment.js'
import { getEncountersHistory } from './encounter.js'

const getGoals = createSelector(Compartment.unmappedGoals, goals =>
  _.chain(goals)
    .filter(g => g.date && g.goal)
    .map(g => ({
      type: 'goal',
      datetime: g.date,
      title: g.goal
    }))
    .value())

// Get Admissions  from fhir/Encounter where type.in ()
// `/patients/${patientId}/fhir/Encounter?patient=Patient/${patientId}&type=inpatient_hospital,ed,inpatient_w_icu,provider_appointment,post_acute,snf,hospice&_count=99999`
const getAdmissions = createSelector(
  Compartment.unmappedAdmissions,
  admissions =>
    admissions.map(a => ({
      type: 'admission',
      datetime: a.admissionDate,
        title: a?.type?.display ?? null
    }))
)

// Get Procedures
// `/patients/${patientId}/fhir/Procedure?subject=Patient/${patientId}&_count=99999`
const getProcedures = createSelector(
  Compartment.unmappedProcedures,
  procedures =>
    _.chain(procedures)
      .filter(p => p.date && p.type)
      .map(p => ({
        type: 'procedure',
        datetime: p.date,
        title: p.type
      }))
      .value()
)

const getActivity = redux => redux.encountersHistory?.activity || []

export const getTimeline = createSelector(
  [ getEncountersHistory, getGoals, getAdmissions, getProcedures, getActivity ],
  (encounterHistoryItems, goals, admissions, procedures, activity) => [ ...encounterHistoryItems, ...goals, ...admissions, ...procedures, ...activity ].sort(
    (i1, i2) => moment(i2.datetime)
      .diff(moment(i1.datetime))
  )
)
